import React, { createContext, useState, useCallback } from 'react';
import axios from 'axios';
const BASE_URL = process.env.REACT_APP_BASE_URL; // Adjust the base URL as needed

export const AppointmentContext = createContext();

const AppointmentProvider = ({ children }) => {
  const [appointments, setAppointments] = useState([]);

  const fetchAppointments = useCallback(async () => {
    try {
      const token = localStorage.getItem('token'); // or 'token' depending on your storage key
      const response = await axios.get(`${BASE_URL}/api/doctor/appointments`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setAppointments(response.data);
    } catch (error) {
      console.error('Error fetching appointments:', error);
    }
  }, []);

  const updateAppointment = useCallback(
    async (appointmentId, updates) => {
      try {
        await axios.put(
          `${BASE_URL}/api/doctor/appointments/${appointmentId}`,
          updates,
        );
        fetchAppointments(); // Refresh appointments after update
      } catch (error) {
        console.error('Error updating appointment:', error);
      }
    },
    [fetchAppointments],
  );

  return (
    <AppointmentContext.Provider
      value={{ appointments, fetchAppointments, updateAppointment }}
    >
      {children}
    </AppointmentContext.Provider>
  );
};

// Export both the context and the provider
export { AppointmentProvider };
export default AppointmentProvider;
